/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import _ from 'lodash'
import NProgress from 'nprogress'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import ReservationListView from '../../view/pages/reservations/ReservationListView'
import ReservationSearchStore from '../../store/reservation/ReservationSearchStore'
import ReservationAction from '../../action/reservation'
import ReservationsStore from '../../store/reservation/ReservationsStore'
import ReservationStore from '../../store/reservation/ReservationStore'
import ReservationPaginationStore from '../../store/reservation/ReservationPaginationStore'
import SessionStore from '../../store/SessionStore'
import SessionAction from '../../action/session'
import AuditsStore from '../../store/AuditsStore'
import AutoActionLogsStore from '../../store/auto_action/AutoActionLogsStore'
import AccommodationInvoicesStore from '../../store/reservation/AccommodationInvoicesStore'
import SiteReferrerOptionsStore from '../../store/options/SiteReferrerOptionsStore'
import SiteReferrerAction, { SiteReferrerAvailableType } from '../../action/site_referrer'

class ReservationListContainer extends Component {
  static getStores() {
    return [ReservationsStore, ReservationSearchStore, ReservationPaginationStore, SiteReferrerOptionsStore]
  }

  static calculateState(prevState, props) {
    return {
      reservations: ReservationsStore.getState(),
      reservation: ReservationStore.getState(),
      search: ReservationSearchStore.getState(),
      invoices: AccommodationInvoicesStore.getState(),
      audits: AuditsStore.getState(),
      auto_action_logs: AutoActionLogsStore.getState(),
      pagination: ReservationPaginationStore.getState(),
      session: SessionStore.getState(),
      site_referrer_options: SiteReferrerOptionsStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()
    // ReservationDetail
    const id = this.state.match.params.id
    if (id) {
      const tab = _.propertyOf(this.state.match.params)('tab')
      await ReservationAction.getReservation(tab, id)
    }
    await ReservationAction.onSearch(this.state.search, this.state.pagination)
    SessionAction.fetchUserHotels()
    SiteReferrerAction.fetchSiteReferrers(SiteReferrerAvailableType.RESERVATION)

    NProgress.done()
  }

  render() {
    return ReservationListView(this.state)
  }
}

export default withRouter(Container.create(ReservationListContainer, { withProps: true }))
